import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import {TFetch} from "../../types";
import reducerStatuses from "../../status";
import {AUTH, DONE, FAIL, FETCH,RESET, REGISTER_DATA,RESTORE_DATA, SET, GET_PROFILE, EMBED_DATA, GET_MODULES, SPECIALISTS, REVIEWS_LIST, RESEND_CODE, CONFIRM_RESET_PASSWORD, CONFIRM_PASSWORD} from "../../constants";

const initialState: TFetch = {
  userProfile: {
    ...reducerStatuses,
    data: {} as any,
  },
  userRole: {
    ...reducerStatuses,
    data: {} as any,
  },
  userData: {
    ...reducerStatuses,
    data: {} as any,
  },
  userMenu: {
    ...reducerStatuses,
    data: {} as any,
  },
  registerData: {
    ...reducerStatuses,
    data: {} as any,
  },
  restoreData: {
    ...reducerStatuses,
    data: {} as any,
  },
  modulesData: {
    ...reducerStatuses,
    data: {} as any,
  },
  resetData: {
    ...reducerStatuses,
    data: {} as any,
  },
  embedData: {
    ...reducerStatuses,
    data: null,
  },
  specialistsData: {
    ...reducerStatuses,
    data: null,
  },
  reviewsList: {
    ...reducerStatuses,
    data: null,
  },
  resendCode: {
    ...reducerStatuses,
    data: null as any,
  },
  confirmResetPassword: {
    ...reducerStatuses,
    data: null as any,
  },
  confirmPassword: {
    ...reducerStatuses,
    data: null as any,
  },
}

export default createReducer(initialState, builder =>
  builder
    .addCase(AUTH + FETCH, (state) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile,
        loading: true
      }
    }))
    .addCase(AUTH + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile,
        success: true,
        data: payload
      }
    }))
    .addCase(AUTH + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile,
        failed: true,
        data: payload
      }
    }))
    
    .addCase(AUTH + RESET, (state) => ({
      ...state,
      userProfile: {
        ...initialState.userProfile
      }
    }))

    .addCase(REGISTER_DATA + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      registerData: {
        ...initialState.registerData,
        data: payload,
        loading: true,
      }
    }))
    .addCase(REGISTER_DATA + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      registerData: {
        ...initialState.registerData,
        success: true,
        data: payload
      }
    }))
    .addCase(REGISTER_DATA + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      registerData: {
        ...initialState.registerData,
        failed: true,
        data: payload
      }
    }))

    .addCase(RESTORE_DATA + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      restoreData: {
        ...initialState.restoreData,
        data: payload,
        loading: true,
      }
    }))
    .addCase(RESTORE_DATA + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      restoreData: {
        ...initialState.restoreData,
        success: true,
        data: payload.request,
        message: payload.response.message,
      }
    }))
    .addCase(RESTORE_DATA + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      restoreData: {
        ...initialState.restoreData,
        failed: true,
        data: payload
      }
    }))

    .addCase(GET_MODULES + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      modulesData: {
        ...initialState.modulesData,
        data: payload,
        loading: true,
      }
    }))
    .addCase(GET_MODULES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      modulesData: {
        ...initialState.modulesData,
        success: true,
        data: payload
      }
    }))
    .addCase(GET_MODULES + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      modulesData: {
        ...initialState.modulesData,
        failed: true,
        data: payload
      }
    }))
    .addCase(GET_PROFILE + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      userData: {
        ...initialState.userData,
        data: payload,
        loading: true,
      }
    }))
    .addCase(GET_PROFILE + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      userData: {
        ...initialState.userData,
        success: true,
        data: payload
      }
    }))
    .addCase(GET_PROFILE + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      userData: {
        ...initialState.userData,
        failed: true,
        data: payload
      }
    }))
    .addCase(REGISTER_DATA + RESET, (state) => ({
      ...state,
      registerData: {
        ...initialState.registerData,
      },
    }))
    .addCase(SET + EMBED_DATA, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      embedData: {
        ...state.embedData,
        data: payload
      }
    }))
    .addCase(SET + RESTORE_DATA, (state) => ({
      ...state,
      restoreData: {
        ...initialState.restoreData,
      }
    }))
    .addCase(SET + REGISTER_DATA, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      registerData: {
        ...state.registerData,
        data: payload
      }
    }))
    .addCase(SPECIALISTS + FETCH, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      specialistsData: {
        ...initialState.specialistsData,
        data: payload,
        loading: true,
      }
    }))
    .addCase(SPECIALISTS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      specialistsData: {
        ...initialState.specialistsData,
        success: true,
        data: payload
      }
    }))
    .addCase(SPECIALISTS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      specialistsData: {
        ...initialState.specialistsData,
        failed: true,
        data: payload
      }
    }))
    .addCase(REVIEWS_LIST + FETCH, (state) => ({
      ...state,
      reviewsList: {
        ...initialState.reviewsList,
        loading: true,
      },
    }))
    .addCase(REVIEWS_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      reviewsList: {
        ...initialState.reviewsList,
        success: true,
        data: payload,
      },
    }))
    .addCase(REVIEWS_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      reviewsList: {
        ...initialState.reviewsList,
        failed: true,
        data: payload,
      },
    }))
    .addCase(RESEND_CODE + FETCH, (state) => ({
      ...state,
      resendCode: {
        ...initialState.resendCode,
        loading: true,
      },
    }))
    .addCase(RESEND_CODE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      resendCode: {
        ...initialState.resendCode,
        success: true,
        data: payload,
      },
    }))
    .addCase(RESEND_CODE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      resendCode: {
        ...initialState.resendCode,
        failed: true,
        data: payload,
      },
    }))
    .addCase(CONFIRM_RESET_PASSWORD + FETCH, (state) => ({
      ...state,
      confirmResetPassword: {
        ...initialState.confirmResetPassword,
        loading: true,
      },
    }))
    .addCase(CONFIRM_RESET_PASSWORD + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      confirmResetPassword: {
        ...initialState.confirmResetPassword,
        success: true,
        data: payload,
      },
    }))
    .addCase(CONFIRM_RESET_PASSWORD + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      confirmResetPassword: {
        ...initialState.confirmResetPassword,
        failed: true,
        data: payload,
      },
    }))
    .addCase(CONFIRM_PASSWORD + FETCH, (state) => ({
      ...state,
      confirmPassword: {
        ...initialState.confirmPassword,
        loading: true,
      },
    }))
    .addCase(CONFIRM_PASSWORD + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      confirmPassword: {
        ...initialState.confirmPassword,
        success: true,
        data: payload,
      },
    }))
    .addCase(CONFIRM_PASSWORD + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      confirmPassword: {
        ...initialState.confirmPassword,
        failed: true,
        data: payload,
      },
    }))
)